import { supabase } from "@/integrations/supabase/client";

export async function geocodeAddress(address: string): Promise<{ latitude: number; longitude: number } | null> {
  try {
    const { data, error } = await supabase.functions.invoke("geocode-address", {
      body: { address },
    });
    if (error) {
      console.error("Geocode function error:", error);
      return null;
    }
    if (data?.latitude != null && data?.longitude != null) {
      return { latitude: data.latitude, longitude: data.longitude };
    }
    return null;
  } catch (err) {
    console.error("Geocode error:", err);
    return null;
  }
}

export function buildAddressString(fields: {
  street_address?: string;
  city?: string;
  province_state?: string;
  postal_zip_code?: string;
  country?: string;
}): string {
  return [
    fields.street_address,
    fields.city,
    fields.province_state,
    fields.postal_zip_code,
    fields.country,
  ]
    .filter(Boolean)
    .join(", ");
}
